module.exports = __webpack_public_path__ + "img/report.cb79c92a.png";